<template>
  <!-- exhibition-company-brand .ecb -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">管理</BreadcrumbItem>
          <BreadcrumbItem>人员</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="add=true">
          <span class="htb-add">+</span>
          <span>添加人员</span>
        </div>
      </div>
    </div>
    <div class="admin">
      <div class="admin-top">
        <div class="admin-top-title">
          <p style="font-size:18px;color:#222;">管理员信息</p>
          <Button
          type="primary"
          :stripe="false"
          ghost
          style="width:56px; height:32px"
          @click="editAdmin=true"
        >修改</Button>
        </div>
        <div class="admin-top-info"> 
          <img v-if="formInline.headImgUrl" :src="formInline.headImgUrl" style="width:150px;height:150px;border-radius:50%;" />
          <img v-else src="@assets/img/empty.png" style="width:150px;height:150px;border-radius:50%;" />
          <div style="margin-left:20px;">
            <p>姓名：{{ formInline.name }}</p>
            <p>职务：{{ formInline.jobTitle }}</p>
            <p>手机：{{ formInline.phoneNumber | toTel }}</p>
          </div>
        </div>
        <!-- <div class="admin-top-form">
          <Form ref="formInline" :model="formInline" :rules="ruleValidate" :label-width="100">
            <FormItem label="姓名：" prop="name">
              <Input v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="公司职位：" prop="jobTitle">
              <Input v-model="formInline.jobTitle" placeholder="请输入职位" />
            </FormItem>
            <FormItem>
              <Button
                type="primary"
                :loading="loading1"
                @click="handleSubmit('formInline')"
                style="width:82px; height:32px"
              >保存</Button>
            </FormItem>
          </Form>
        </div> -->
      </div>
      <div class="admin-center">
        <p>人员</p>
        <!-- <Button
          type="primary"
          :stripe="false"
          style="width:100px; height:32px"
          @click="add=true"
        >绑定运营者</Button> -->
      </div>
      <div class="admin-bottom" v-if="staffInfo && staffInfo.length">
        <Row :gutter="15">
          <Col span="4" v-for="(item, index) in staffInfo" :key="'Admin-' + index">
            <div v-if="!item.isShow" class="admin-show"><i class="icon iconfont icon-hide"></i></div>
            <div class="my-item-box">
              <div class="my-item-box-top">
                <img :src="item.headImgUrl" v-if="item.headImgUrl" />
                <img src="@assets/img/empty.png" v-else />
              </div>
              <div class="my-item-box-title f-tac" :title="item.name">{{item.name}}</div>
              <div class="my-item-box-tool">
                <Row type="flex" justify="center">
                  <Col span="8" style="text-align:center;border-right:1px solid #e8e8e8;">
                    <div class="my-item-box-tool-item z-del">
                      <Poptip confirm title="确认删除吗 ?" @on-ok="delItem(item)">删除</Poptip>
                    </div>
                  </Col>
                  <Col span="8" style="text-align:center;border-right:1px solid #e8e8e8;">
                    <div class="my-item-box-tool-item" v-if="item.isShow" @click="showOff(item)">屏蔽</div>
                    <div class="my-item-box-tool-item" v-if="!item.isShow" @click="showOn(item)">显示</div>
                  </Col>
                  <Col span="8" style="text-align:center;">
                     <div class="my-item-box-tool-item" @click="EditOperate(item)">编辑</div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <!-- <Table
          :border="false"
          :columns="columns1"
          :data="staffInfo"
          :loading="loading"
          :disabled-hover="false"
        >
          <template slot-scope="{ row, index }" slot="action">
            <Poptip confirm title="确认是否解绑?" @on-ok="unbind(row)" :transfer="true">
              <Button type="text" size="small" style="color: #f00;">解除绑定</Button>
            </Poptip>
          </template>
        </Table> -->
      </div>
      <div class="admin-bottom" style="text-align:center;" v-else>暂无数据</div>
    </div>
    <Contact /> 
    <!-- 新增人员 -->
    <Addoperate :show="add" @finish="init()" @close="add=false" />
    <Editoperate v-if="editOperate" :editOperateInfo="editOperateInfo" @finish="init()" @close="editOperate=false" />
    <Editadmin :show="editAdmin" :admininfo="adminInfo" @finish="init()" @close="editAdmin=false" />
    <!-- <bindOperate :show="add" @finish="init()" @close="add=false" /> -->
  </div>
</template>

<script>
import Contact from "@components/Contact/Contact";
import Addoperate from "./subpages/add-operate.vue";
import Editoperate from "./subpages/edit-operate.vue";
import Editadmin from "./subpages/edit-admin.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  // 管理员资料
  name: "exhibition-control-admin",
  filters: {
    toTel: function(value) {
      let start = value.slice(0, 3);
      let end = value.slice(-4);
      return `${start}****${end}`;
    }
  },
  data() {
    return {
      add: false, // 控制增加人员弹框
      editAdmin: false, // 控制修改管理员弹框
      editOperate: false, // 控制编辑人员弹框
      loading: false,
      loading1: false,
      loading2: false,
      bindflag: false,

      formInline: {
        name: "",
        jobTitle: "",
        phoneNumber: "",
        headImgUrl: "",
        email: ""
      },
      ruleValidate: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        jobTitle: [{ required: true, message: "职位不能为空", trigger: "blur" }]
      },
      staffInfo: [], // 员工信息
      adminInfo: null, // 管理员信息
      editOperateInfo: null,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    })
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      register: "registerModule/registerExhibition",
      getStaffAllByCompId: "companyModule/getStaffAllByCompId",
      delStaff: "companyModule/delStaff",
      editStaff: "companyModule/editStaff",
      addStaff: "companyModule/addStaff"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Id: this.adminInfo.staffId,
        SetValues: {
          Name: this.formInline.name,
          JobTitle: this.formInline.jobTitle,
          phoneNumber: this.formInline.phoneNumber,
          email: this.formInline.email
        }
      };
      this.loading1 = true;
      let bool = await this.editStaff(req).catch(e => {
        this.loading1 = false;
      });
      this.loading1 = false;
      this.$Message.success("编辑成功");
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async init() {
      let arr = [];
      let staffArr = await this.getStaffAllByCompId(this.company.id);
      staffArr.forEach(c => {
        if (c.roleId === 0) {
          arr.push(c);
        }
        if (c.roleId === 1) {
          this.adminInfo = c;
        }
      });
      this.staffInfo = arr
      if (this.adminInfo) {
        this.formInline.name = this.adminInfo.name;
        this.formInline.jobTitle = this.adminInfo.jobTitle || "";
        this.formInline.phoneNumber = this.adminInfo.phoneNumber;
        this.formInline.email = this.adminInfo.email;
        this.formInline.headImgUrl = this.adminInfo.headImgUrl;
      }
      console.log("this.staffInfo", this.staffInfo);
    },
    async unbind(item) {
      let result = await this.delStaff(item.staffId).catch(e =>
        this.$Message.error("解除绑定失败，请重新尝试")
      );
      if (result.successed) {
        this.$Message.success("解除绑定成功");
        this.init();
      } else {
        this.$Message.error("解除绑定失败，请重新尝试");
      }
    },
    EditOperate(value) {
      this.editOperateInfo = value;
      this.editOperate = true;
    },
    // 屏蔽
    async showOff(value) {
      let req = {
        Id: value.staffId,
        SetValues: {
          Name: value.name,
          IsShow: false,
          ShowIndex: value.showIndex
        }
      }
      let bool = await this.editStaff(req).catch(err => {
        this.loading = false;
      });
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败");
      }
    },
    // 显示
    async showOn(value) {
      let req = {
        Id: value.staffId,
        SetValues: {
          Name: value.name,
          IsShow: true,
          ShowIndex: value.showIndex
        }
      }
      let bool = await this.editStaff(req).catch(err => {
        this.loading = false;
      });
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败");
      }
    },
    async delItem(value) {
      let result = await this.delStaff(value.staffId);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    }
  },
  components: {
    Contact,
    Addoperate,
    Editadmin,
    Editoperate
    // bindOperate
  }
};
</script>

<style lang="scss">
.admin-bottom {
  .ivu-table th,
  .ivu-table td,
  .ivu-table-wrapper {
    border: none;
  }
  .ivu-table th {
    background: #fff;
    border-bottom: 2px solid #f2f2f2;
    text-align: center;
  }
  .ivu-table td {
    text-align: center;
  }
}
</style>

<style scope lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
</style>
<style scoped lang="scss">
.admin {
  width: 100%;
  min-height: 500px;
  background-color: #f0f2f5;
  padding: 25px;
  &-top {
    min-width: 600px;
    padding: 0 0 20px 0;
    background-color: #fff;
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 30px 10px 30px;
      border-bottom: 1px solid #e8e8e8;
    }
    &-info {
      margin: 20px;
      display: flex;
      align-items: center;
    }
  }
  &-center {
    background-color: #fff;
    padding: 0 0 10px 30px;
    border-bottom: 1px solid #e8e8e8;
    p {
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      color: #222222;
    }
  }
  &-bottom {
    background-color: #fff;
    min-width: 1000px;
    padding: 30px;
    .my-item-box {
      background-color: #fff;
      margin-bottom: 30px;
      padding: 20px;
      box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
	    border-radius: 2px;
      &-top {
        width: 100%;
        padding-bottom: 66.666667%;
        position: relative;
        background-color: #f8f9fb;
        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      &-title {
        background: #fff;
        height: 66px;
        padding: 20px 10px 7px 12px;
        font-size: 16px;
      }
      &-tool {
        height: 48px;
        background-color: #fff;

        &-item {
          // font-size: 14px;
          color: #808080;
          cursor: pointer;
          &:hover {
            color: #1890ff;
          }

          &.z-del {
            &:hover {
              color: #f00;
            }
          }
        }
      }
    }
  }
}
.admin-show {
  position:absolute;
  z-index: 1;
  right: 8px;
  width: 0; 
  height: 0;
  border-width: 20px;
  border-style: solid;
  border-color:#ccc #ccc transparent transparent;
  i {
    position: absolute;
    top: -25px;
    right: -20px;
    color: #fff;
    font-size: 25px;
  }
}
</style>
